// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.neon-text-free-visit {
  color: #ffffff;
  /* text-shadow:
    0 0 15px #39ff14,
    0 0 30px #39ff14,
    0 0 60px #2aff1e77; */
}

.neon-bg {
  background: linear-gradient(180deg, #001430, black);
  opacity: 0.4;
  position: absolute;
}

.middle-title{
  font-size: 21px;

}

.neon-circle-free-visit {
  position: absolute;
  width: 800px;
  height: 800px;
  /* background: radial-gradient(circle, #39ff14aa, transparent 70%); */
  top: -200px;
  right: -200px;
  filter: blur(100px);
  opacity: 0.35;
}

.neon-card {
  background: rgba(10, 10, 10, 0.5);
  border: 2px solid rgba(20, 79, 255, 0.4);
  backdrop-filter: blur(18px);
  /* box-shadow:
    0 0 20px rgba(57,255,20,0.6),
    0 0 40px rgba(57,255,20,0.3); */
}

.form-label {
  display: block;
  margin-bottom: 6px;
  font-size: 0.9rem;
  /* color: #d8ffd3; */
}

.form-input {
  width: 100%;
  padding: 12px 14px;
  font-size: 0.9rem;
  border-radius: 10px;
  outline: none;
  border: none;
  background: #111;
  /* color: #d8ffd3; */
  margin: 8px;
}

.neon-input {
  border: 1px solid #1462ff77;
  /* box-shadow:
    0 0 8px #39ff1444,
    inset 0 0 10px #39ff1422; */
}

.neon-input:focus {
  border-color: #144ffff6;
  /* box-shadow:
    0 0 15px #39ff14,
    inset 0 0 20px #39ff1433; */
}

.neon-btn {
  background:rgb(132 204 22 / var(--tw-bg-opacity, 1));
  color: black;
  border-radius: 12px;
  /* box-shadow:
    0 0 15px #39ff14,
    0 0 30px #39ff1477; */
  transition: 0.3s ease;
}

.neon-btn:hover {
  background: #a0b6ff;
}
`, "",{"version":3,"sources":["webpack://./src/pages/visit.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd;;;yBAGuB;AACzB;;AAEA;EACE,mDAAmD;EACnD,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;;AAEjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,qEAAqE;EACrE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,wCAAwC;EACxC,2BAA2B;EAC3B;;mCAEiC;AACnC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B;;+BAE6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB;;+BAE6B;AAC/B;;AAEA;EACE,oDAAoD;EACpD,YAAY;EACZ,mBAAmB;EACnB;;yBAEuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".neon-text-free-visit {\n  color: #ffffff;\n  /* text-shadow:\n    0 0 15px #39ff14,\n    0 0 30px #39ff14,\n    0 0 60px #2aff1e77; */\n}\n\n.neon-bg {\n  background: linear-gradient(180deg, #001430, black);\n  opacity: 0.4;\n  position: absolute;\n}\n\n.middle-title{\n  font-size: 21px;\n\n}\n\n.neon-circle-free-visit {\n  position: absolute;\n  width: 800px;\n  height: 800px;\n  /* background: radial-gradient(circle, #39ff14aa, transparent 70%); */\n  top: -200px;\n  right: -200px;\n  filter: blur(100px);\n  opacity: 0.35;\n}\n\n.neon-card {\n  background: rgba(10, 10, 10, 0.5);\n  border: 2px solid rgba(20, 79, 255, 0.4);\n  backdrop-filter: blur(18px);\n  /* box-shadow:\n    0 0 20px rgba(57,255,20,0.6),\n    0 0 40px rgba(57,255,20,0.3); */\n}\n\n.form-label {\n  display: block;\n  margin-bottom: 6px;\n  font-size: 0.9rem;\n  /* color: #d8ffd3; */\n}\n\n.form-input {\n  width: 100%;\n  padding: 12px 14px;\n  font-size: 0.9rem;\n  border-radius: 10px;\n  outline: none;\n  border: none;\n  background: #111;\n  /* color: #d8ffd3; */\n  margin: 8px;\n}\n\n.neon-input {\n  border: 1px solid #1462ff77;\n  /* box-shadow:\n    0 0 8px #39ff1444,\n    inset 0 0 10px #39ff1422; */\n}\n\n.neon-input:focus {\n  border-color: #144ffff6;\n  /* box-shadow:\n    0 0 15px #39ff14,\n    inset 0 0 20px #39ff1433; */\n}\n\n.neon-btn {\n  background:rgb(132 204 22 / var(--tw-bg-opacity, 1));\n  color: black;\n  border-radius: 12px;\n  /* box-shadow:\n    0 0 15px #39ff14,\n    0 0 30px #39ff1477; */\n  transition: 0.3s ease;\n}\n\n.neon-btn:hover {\n  background: #a0b6ff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
